import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=c5a369a6&scoped=true"
var script = {}
import style0 from "./FAQ.vue?vue&type=style&index=0&id=c5a369a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a369a6",
  null
  
)

export default component.exports